export const ORGANIZATION_CHART_FIELDS = [
  'ticker',
  'balance',
  'amount',
  'thumbnail',
]
